module.exports = __webpack_public_path__ + "static/media/launch.8f8cd3ab.png";